import { render } from "./LexadayPage.vue?vue&type=template&id=634c7fee&scoped=true"
import script from "./LexadayPage.vue?vue&type=script&lang=js"
export * from "./LexadayPage.vue?vue&type=script&lang=js"

import "./LexadayPage.vue?vue&type=style&index=0&id=634c7fee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634c7fee"]])

export default __exports__